import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { AdministrationSummaryService } from '../../services/administration/administration-summary.service';
import { CommonService } from '../../services/common.service';
import * as $ from 'jquery';

@Component({
  selector: 'app-budget-timeline-config',
  templateUrl: './budget-timeline-config.component.html',
  styleUrl: './budget-timeline-config.component.scss'
})
export class BudgetTimelineConfigComponent {

cmeCurrlist :any =[]

startmonths = [
  { label: "Select", value: 0, checked: true },
  { label: "January", value: 1 },
  { label: "February", value: 2 },
  { label: "March", value: 3 },
  { label: "April", value: 4 },
  { label: "May", value: 5 },
  { label: "June", value: 6 },
  { label: "July", value: 7 },
  { label: "August", value: 8 },
  { label: "September", value: 9 },
  { label: "October", value: 10 },
  { label: "November", value: 11 },
  { label: "December", value: 12 },
];
endmonths = [
  { label: "Select", value: 0, checked: true },
  { label: "January", value: 1 },
  { label: "February", value: 2 },
  { label: "March", value: 3 },
  { label: "April", value: 4 },
  { label: "May", value: 5 },
  { label: "June", value: 6 },
  { label: "July", value: 7 },
  { label: "August", value: 8 },
  { label: "September", value: 9 },
  { label: "October", value: 10 },
  { label: "November", value: 11 },
  { label: "December", value: 12 },
];
startDate: any;
endDate: any;
months: any;
timelineForm: UntypedFormGroup;

  constructor(
    public modalRef: NgbActiveModal,
    private summaryService: AdministrationSummaryService,
    private commonservice: CommonService,
  ) {
    this.modalRef.close();
  }

  
  ngOnInit() {
    this.timelineForm = new UntypedFormGroup({
      ID: new UntypedFormControl(""),
      FISCAL_START_MONTH: new UntypedFormControl(4, Validators.required),
      FISCAL_END_MONTH: new UntypedFormControl(3, Validators.required),
      CALENDAR_START_MONTH: new UntypedFormControl(1, Validators.required),
      CALENDAR_END_MONTH: new UntypedFormControl(12, Validators.required)
    });
    this.GetEditData() ;
  }

  GetEditData(): void {
      
    this.summaryService.getSummaryData('api/timeconfig/Edit').subscribe(summary => {
      this.timelineForm.patchValue({
        ID: summary["ID"],
        FISCAL_START_MONTH: parseInt(summary["FISCAL_START_MONTH"]),
        FISCAL_END_MONTH: parseInt(summary["FISCAL_END_MONTH"]),
        CALENDAR_START_MONTH: parseInt(summary["CALENDAR_START_MONTH"]),
        CALENDAR_END_MONTH: parseInt(summary["CALENDAR_END_MONTH"]),
        
      });
            
    });

}


  changeFiscalStartMonth() {
    let fiscalStartMonth = this.timelineForm.controls['FISCAL_START_MONTH'].value;

    if(fiscalStartMonth!=0)
    {
        if(fiscalStartMonth==1)
        {
          fiscalStartMonth=12;
        }
        else
        {
          fiscalStartMonth=fiscalStartMonth-1;
        }
       
          this.timelineForm.controls['FISCAL_END_MONTH'].setValue(fiscalStartMonth);
    }
    
  }
  changeFiscalEndMonth()
  {
    let fiscalStartMonth = this.timelineForm.controls['FISCAL_END_MONTH'].value;

    if(fiscalStartMonth != 0)
    {
        if(fiscalStartMonth==12)
        {
          fiscalStartMonth=1;
        }
        else
        {
          fiscalStartMonth=fiscalStartMonth+1;
        }
       
          this.timelineForm.controls['FISCAL_START_MONTH'].setValue(fiscalStartMonth);
    }
    
  }
  changeCalendarStartMonth() {
    let fiscalStartMonth = this.timelineForm.controls['CALENDAR_START_MONTH'].value;

    if(fiscalStartMonth != 0)
    {
        if(fiscalStartMonth==1)
        {
          fiscalStartMonth=12;
        }
        else
        {
          fiscalStartMonth=fiscalStartMonth-1;
        }
       
          this.timelineForm.controls['CALENDAR_END_MONTH'].setValue(fiscalStartMonth);
    }
    
  }
  changeCalendarEndMonth()
  {
    let fiscalStartMonth = this.timelineForm.controls['CALENDAR_END_MONTH'].value;

    if(fiscalStartMonth != 0)
    {
        if(fiscalStartMonth==12)
        {
          fiscalStartMonth=1;
        }
        else
        {
          fiscalStartMonth=fiscalStartMonth+1;
        }
       
          this.timelineForm.controls['CALENDAR_START_MONTH'].setValue(fiscalStartMonth);
    }
    
  }
    
 

  save() {
    if (this.validateControls()) {
      var formDate = this.timelineForm.getRawValue();
      formDate["FISCAL_START_MONTH"] = String(this.timelineForm.controls["FISCAL_START_MONTH"].value);
      formDate["FISCAL_END_MONTH"] = formDate["FISCAL_END_MONTH"] + '';
      formDate["CALENDAR_START_MONTH"] = formDate["CALENDAR_START_MONTH"] + '';
      formDate["CALENDAR_END_MONTH"] = formDate["CALENDAR_END_MONTH"] + '';

      this.summaryService.Insert('api/timeconfig/insert', formDate).subscribe(summary => {
        if (summary.Status == 0) {
          this.modalRef.close();
          this.commonservice.SuccessBanner(summary.Message);
        }
        else {
          this.commonservice.ValidationBanner(summary.Message);
        }
      });
    }
    
  }

  validateControls(): boolean
  {
    let isValid = true;
        let message = "";
        const formData = this.timelineForm.getRawValue();

        if (formData.FISCAL_START_MONTH === null || formData.FISCAL_START_MONTH === ""||formData.FISCAL_START_MONTH===undefined ||formData.FISCAL_START_MONTH == 0) {
          $("#FISCAL_START_MONTH").addClass("ng-touched ng-invalid validate-error");
          $("#FISCAL_START_MONTH").removeClass("ng-untouched ng-valid");
          message += "Please select Start Month for Fiscal Year <br/>";
          isValid = false;
        }
        else {
          $("#FISCAL_START_MONTH").addClass("ng-untouched ng-valid");
          $("#FISCAL_START_MONTH").removeClass("ng-touched ng-invalid validate-error");
        }
        if (formData.FISCAL_END_MONTH === null || formData.FISCAL_END_MONTH === ""||formData.FISCAL_END_MONTH===undefined ||formData.FISCAL_END_MONTH == 0) {
          $("#FISCAL_END_MONTH").addClass("ng-touched ng-invalid validate-error");
          $("#FISCAL_END_MONTH").removeClass("ng-untouched ng-valid");
          message += "Please select End Month for Fiscal Year <br/>";
          isValid = false;
        }
        else {
          $("#FISCAL_END_MONTH").addClass("ng-untouched ng-valid");
          $("#FISCAL_END_MONTH").removeClass("ng-touched ng-invalid validate-error");
        }
        if (formData.CALENDAR_START_MONTH === null || formData.CALENDAR_START_MONTH === ""||formData.CALENDAR_START_MONTH===undefined ||formData.CALENDAR_START_MONTH == 0) {
          $("#CALENDAR_START_MONTH").addClass("ng-touched ng-invalid validate-error");
          $("#CALENDAR_START_MONTH").removeClass("ng-untouched ng-valid");
          message += "Please select Start Month for Calendar Year <br/>";
          isValid = false;
        }
        else {
          $("#CALENDAR_START_MONTH").addClass("ng-untouched ng-valid");
          $("#CALENDAR_START_MONTH").removeClass("ng-touched ng-invalid validate-error");
        }
        if (formData.CALENDAR_END_MONTH === null || formData.CALENDAR_END_MONTH === ""||formData.CALENDAR_END_MONTH===undefined ||formData.CALENDAR_END_MONTH == 0) {
          $("#CALENDAR_END_MONTH").addClass("ng-touched ng-invalid validate-error");
          $("#CALENDAR_END_MONTH").removeClass("ng-untouched ng-valid");
          message += "Please select End Month for Calendar Year <br/>";
          isValid = false;
        }
        else {
          $("#CALENDAR_END_MONTH").addClass("ng-untouched ng-valid");
          $("#CALENDAR_END_MONTH").removeClass("ng-touched ng-invalid validate-error");
        }

        if (!isValid)
          this.commonservice.ValidationBanner(message);
        return isValid;
  }
  
}
